module.exports = __webpack_public_path__ + "static/media/login.e39734e4.svg";